import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, take, timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private dataService: DataService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const requiredRoles = route.data['roles'] as string[];

    return this.dataService.userData$.pipe(
      // Wait until userData has loaded (skip initial null while Firebase resolves)
      filter(userData => userData !== null),
      take(1),
      // Timeout after 8s in case Firebase never resolves – redirect to login
      timeout(8000),
      map(userData => {
        if (!userData) {
          this.router.navigate(['/dang-nhap']);
          return false;
        }

        const userRoles = userData.role || [];

        if (requiredRoles && requiredRoles.length > 0) {
          const hasRequiredRole = requiredRoles.some(r => userRoles.includes(r));

          if (!hasRequiredRole) {
            this.router.navigate(['/unauthorized']);
            return false;
          }
        }

        return true;
      }),
      catchError(() => {
        // Timeout or other error – redirect to login
        this.router.navigate(['/dang-nhap']);
        return of(false);
      })
    );
  }
}
